import React, { useContext } from 'react'
import { DI, DIProps } from '../../../../../Core'
import useContextLayer from '../../Context/helper';
import { BlockStack, Box, Card, ChoiceList, InlineStack, Layout, RadioButton, Tag, Text } from '@shopify/polaris';
import ReactSelect from 'react-select';
import useContainerState from '../../Context/ContainerState';
import { useTranslation } from 'react-i18next';
import { CategoryProductTypeI } from '../../Editproduct';
import { UserContext } from '../../../../../Actions/NecessaryFun';

const ProductTypeSelector = (props: DIProps) => {
  const { t } = useTranslation();
  const { state } = useContextLayer();
  const { containerState, allProductTypes, categoryProductType, ...context } = useContainerState();
  const { attributeLoader } = useContext<any>(UserContext);

  const productType = categoryProductType?.product_type;

  const renderChildren = <div id="tour_product_type_edit">
    {categoryProductType?.suggested_product_types?.length > 0 && <>
      <Text as='p' tone='subdued'>Showing below the product types that are matching with the category you have selected. Select from them or you may choose a custom product type.</Text>
      <Card>
        <ChoiceList
          title={<Text as='p' fontWeight='semibold'>Select from matched Product Type</Text>}
          choices={categoryProductType?.suggested_product_types?.map((product_type: string) => ({ label: product_type, value: product_type }))}
          selected={[productType]}
          disabled={attributeLoader || containerState?.loaders?.['required_attribute']}
          onChange={(selected) => {
            context?.setCategoryProductType((a: any) => ({
              ...a, product_type: selected[0], currentData: {}, category_data
                : {}, product_type_changed: selected + 'without_params'
            }));
            context.setJSONFeedAttributesData(undefined)
          }}
        />
      </Card>
      <div className='Polaris--OR--Seperator Polaris--OR--Seperator--bg-surface-hover'>
        <span>OR</span>
      </div>
    </>
    }
    <BlockStack gap='100'>
      <Text as='p' fontWeight='semibold'>Select Product Type</Text>
      <ReactSelect
        classNamePrefix="Custom__Select"
        menuPortalTarget={document.getElementById('root')}
        options={[
          ...allProductTypes.filter((a: string) => !categoryProductType?.suggested_product_types?.includes(a)).map((a: string) => ({ label: a, value: a }))
        ]}
        isDisabled={attributeLoader || containerState?.loaders?.['required_attribute']}
        value={allProductTypes.filter((a: string) => !categoryProductType?.suggested_product_types?.includes(a)).includes(productType) ? { label: productType, value: productType } : null}
        placeholder='Please Select'
        onChange={(value: any) => {
          context?.setCategoryProductType((a: any) => ({
            ...a, product_type: value?.value, currentData: {}, category_data
              : {}, product_type_changed: value?.value + 'without_params'
          }));
          context.setJSONFeedAttributesData(undefined)
        }}
      />
      {!productType && <Text as='p' tone={state?.hasError ? 'critical' : 'subdued'}>Select a product type.</Text>}
    </BlockStack>
  </div>

  return (
    <Card roundedAbove='sm'>
      <Layout>
        <Layout.AnnotatedSection
          id="producttitle"
          title={"Product Type"}
          description={"Map appropriate Amazon categories with that of Shopify to improve the reach of your products on the platform."}
        >
          <div className={'Custom-Polaris-Box'}>
            <Box padding='400' background="bg-surface-secondary" borderRadius='300' borderWidth='025' borderColor='border'>
              <BlockStack gap='300'>
                <InlineStack gap="300">
                  <RadioButton
                    label={t("Set product type from Product Template")}
                    id="tour_paroduct_type_default"
                    name="product_type_selector"
                    checked={categoryProductType?.selection_type === "default"}
                    disabled={!state?.shopify_data?.profile_info?.category_settings?.product_type || attributeLoader || containerState?.loaders?.['required_attribute']}
                    onChange={() => {
                      context?.setCategoryProductType((prev: CategoryProductTypeI) => ({
                        ...prev,
                        selection_type: "default",
                        currentData: state?.shopify_data?.profile_info?.attributes_mapping?.data?.jsonFeed ?? {},
                        product_type: state?.shopify_data?.profile_info?.category_settings?.product_type ?? ""
                      }));
                      state?.onSaveBarChange(categoryProductType?.init_selection_type !== "default", "product_type_selection");
                      // SET jsonFeed false so that if initially default was selected it should be false and in case custom was selected initially, contextaul will be shown on the basis of product_type_selection
                      state?.onSaveBarChange(false, "jsonFeed");
                    }}
                  />
                  <RadioButton
                    label={t("Set a New Product Type")}
                    id="tour_product_type_custom"
                    name="product_type_selector"
                    checked={categoryProductType?.selection_type === "custom"}
                    disabled={attributeLoader || containerState?.loaders?.['required_attribute']}
                    onChange={() => {
                      state?.onSaveBarChange(categoryProductType?.init_selection_type !== "custom", "product_type_selection");
                      context?.setCategoryProductType((prev: CategoryProductTypeI) => ({ ...prev, selection_type: "custom" }));
                      context?.setRenderJSONFeed(true)
                    }}
                  />
                </InlineStack>
                {categoryProductType?.selection_type === "custom" ? renderChildren :
                  <Tag>Product Type: {categoryProductType?.product_type}</Tag>
                }
              </BlockStack>
            </Box>
          </div>
        </Layout.AnnotatedSection>
      </Layout>
    </Card>
  )
}

export default DI(ProductTypeSelector)